import { History, Project } from "../graphql/types"
import { allExaminations } from "./allExaminations"

/**
 * This function takes a Project object and returns an array of History objects
 * sorted by the createdAt date in descending order.
 *
 * @param {Project} project - The project object containing examinations and history.
 * @returns {History[]} - Sorted array of history objects.
 *
 * Usage:
 * const sortedHistory = getSortedHistoryForProject(project);
 */

export const getSortedHistoryForProject = (project: Project): History[] => {
  const allHistory = allExaminations(project).flatMap(
    (examination) => examination.history
  )
  return allHistory.sort(
    (b, a) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
  )
}
